<template>
  <el-container class="login-container">

    <div class="QRcodeMain">
      <div class="cardHeader">
        <img src="../../assets/zqx.png" alt="" srcset="" style="width: 40px; height: 40px;">
        足球行赛事管理系统
      </div>
      <div class="cardBody">
        <div class="newsArea">
          <img src="../../assets/xieuxiaoguanl.png" alt="" style="width: 200px;height: 250px;">
        </div>
        <div id="weixin" class="QRcode"></div>
      </div>
    </div>
    <div class="footerRow">
      <div>技术支持：安徽白色彗星信息科技有限公司</div>
<!--      <div style="margin: 5px 0">备案号</div>-->
    </div>
  </el-container>
</template>
<script src="https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js">
</script>
  <script>
    !function (a, b, c) {
      function d (a) {
        var c = "default"
        a.self_redirect === !0 ? c = "true" : a.self_redirect === !1 && (c = "false")
        var d = b.createElement("iframe"),
          e = "https://open.weixin.qq.com/connect/qrconnect?appid=" + a.appid + "&scope=" + a.scope + "&redirect_uri=" + a.redirect_uri + "&state=" + a.state + "&login_type=jssdk&self_redirect=" + c + '&styletype=' + (a.styletype || '') + '&sizetype=' + (a.sizetype || '') + '&bgcolor=' + (a.bgcolor || '') + '&rst=' + (a.rst || '')
        e += a.style ? "&style=" + a.style : "",
          e += a.href ? "&href=" + a.href : "",
          d.src = e,
          d.frameBorder = "0",
          d.allowTransparency = "true",
          d.sandbox = "allow-scripts allow-top-navigation allow-same-origin", //重点
          d.scrolling = "no",
          d.width = "300px",
          d.height = "400px"
        var f = b.getElementById(a.id)
        f.innerHTML = "",
          f.appendChild(d)
      }
      a.WxLogin = d
    }(window, document);

export default {
  data() {
    return {
      banner:[
        {
          image:"https://img1.baidu.com/it/u=3183565747,4085678136&fm=253&fmt=auto&app=138&f=JPEG?w=1000&h=500"
        },
        {
          image:"https://img0.baidu.com/it/u=3447847323,3579500877&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=310"
        }
      ],
      banner2:[
        {
          image:"https://img2.baidu.com/it/u=1664375150,2646904745&fm=253&fmt=auto&app=120&f=JPEG?w=465&h=300"
        },
        {
          image:"https://img0.baidu.com/it/u=3437919487,1968736136&fm=253&fmt=auto&app=138&f=JPEG?w=500&h=502"
        }
      ]
    };
  },

  methods: {
    getCodeMes() {
      let code = this.getQueryString("code");
      console.log("地址中的code:", code);
      if (!code) {
        this.createWxQrcode();
      } else {
        this.getLoginMes(code);
      }
    },

    //使用正则读取url里的code
    getQueryString(name) {
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
      // console.log(window.location.search);
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return "";
    },

    async getLoginMes(code) {
      console.log('通过返回的code获取后台token:', code);
      const { res } = await this.$http.get(`/AdminUser/MatchOrgCheckLogin?code=${code}`);
      if (res.isSuccess) {
        localStorage.setItem('Authorization', res.data.token);
        localStorage.setItem('user_info', JSON.stringify(res.data.info));

        this.$http.get('/Match/GetMatchPageList').then(response => {
          if (response.res.isSuccess) {
            const matchList = response.res.data || [];
            if (matchList.length) {
              localStorage.setItem('matchId', matchList[0].matchId);
              localStorage.setItem('currentMatchId', JSON.stringify(matchList[0]));
            }
            location.reload();
          }
        });
      }else{
        this.createWxQrcode()
      }
    },

    createWxQrcode() {
      // 生成微信登录二维码
      var obj = new WxLogin({
        self_redirect: false,
        id: "weixin", // 页面显示二维码的容器id
        appid: "wx6b5cd40af3b86494", // 微信官方提供的测试id
        scope: "snsapi_login",
        //  redirect_uri: encodeURI("http://saishi.ladesports.com/logindev/login"), // 微信官方中的测试环境url地址
         redirect_uri: encodeURI("http://saishi.ladesports.com/login"), // 微信官方中的测试环境url地址
        state: "bind",
        style: "black",
        secret:"c0ce602f247cace43a0744c1e473b7e6",
        href: "",
      });
    }
  },
  mounted() {
    // this.createWxQrcode();
    this.getCodeMes();
  }
};


</script>

<style lang="scss" scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  //background-image: url("../../assets/1202-saishi.jpg");
  //background: url(../../assets/1202-saishi.jpg) repeat left top;
  background: url(../../assets/mazhuolainm.jpg) no-repeat center/cover;

  .QRcodeMain {
    position: absolute;
    width: auto;
    //height: 450px;
    margin: 0 auto;
    border-radius: 25px;
    background: rgba(239, 244, 255, 0.8);
  }

  .QRcode {
    width: 350px;
    height: 100%;
    padding: 20px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    border-radius: 5px;
    display: flex;
  }

  .newsArea {
    width: 350px;
    height: 100%;
    padding: 20px;
    //margin-top: 30px;
    //border-right: 1px solid #eeeeee;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .newPart1,
  .newPart2 {
    margin-top: 28px;
  }

  .bannerText {
    height: 30px;
    display: flex;
    align-items: center;
  }

  .line {
    height: 15px;
    width: 4px;
    border-radius: 10px;
    margin-right: 3px;
    background-color: #bdbdbd;
  }
}
.cardHeader{
  width: 100%;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}
.cardBody{
  display: flex;
  align-items: center;
}
.footerRow{
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
